import React, { useContext } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Frame } from '@shopify/polaris';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import styled from 'styled-components';

import SalesEstimateSidebar from './salesEstimateModules/navigation/components/SalesEstimateSidebar';

import ChillerLogSidebar from './chillerModules/navigation/components/Sidebar';
import ChillerLogUpcomingJobs from './chillerModules/upcomingJobs/pages/UpcomingJobsList';
import ChillerJobApprovalsList from './chillerModules/jobApprovals/pages/JobApprovalsList';
import ChillerLogFieldSettingsPage from './chillerModules/logFields/pages/ChillerLogFieldSettingsPage';

import BackflowSidebar from './backflowTestingModules/navigation/components/BackflowSidebar';
import BackflowJobGroupsListPage from './backflowTestingModules/backflowJobLists/pages/BackflowJobGroupsListPage';
import BackflowJobGroupDetailPage from './backflowTestingModules/backflowJobLists/pages/BackflowJobGroupDetailPage';
import BackflowTestApprovalsListPage from './backflowTestingModules/backflowJobLists/pages/BackflowTestsApprovalsQueuePage';
import FlaggedDevicesListPage from './backflowTestingModules/flaggedDevices/pages/FlaggedDevicesListPage';
import UnsubmittedTestsPage from './backflowTestingModules/backflowJobLists/pages/UnsubmittedTestsPage';
import WaterAuthoritySubmissionsPage from './backflowTestingModules/waterAuthoritySubmissions/pages/WaterAuthoritySubmissionsPage';
import WaterAuthoritySubmissionReviewPage from './backflowTestingModules/waterAuthoritySubmissions/pages/WaterAuthoritySubmissionReviewPage';
import WaterAuthorityListPage from './backflowTestingModules/waterAuthorityConfig/pages/WaterAuthorityListPage';
import WaterAuthorityDetailPage from './backflowTestingModules/waterAuthorityConfig/pages/WaterAuthorityDetailPage';
import WaterAuthorityCreatePage from './backflowTestingModules/waterAuthorityConfig/pages/WaterAuthorityCreatePage';
import BackflowLogPage from './backflowTestingModules/backflowJobForms/pages/BackflowLogPage';
import BackflowPlumberDetailsPage from './backflowTestingModules/plumberConfig/pages/BackflowPlumberDetailsPage';
import ServmanSqlLogsPage from './developerModules/servmanSqlLogs/ServmanSqlLogsPage';
import CallbackResultsPage from './developerModules/callbackResults/CallbackResultsPage';

import CustomerIssuesSidebar from './customerIssuesModules/navigation/components/CustomerIssuesSidebar';
import CustomerIssuesListPage from './customerIssuesModules/customerIssuesList/pages/CustomerIssuesListPage';
import CustomerIssueDetailPage from './customerIssuesModules/customerIssuesList/pages/CustomerIssueDetailPage';

import ProjectCommunicationsSidebar from './projectCommunicationsModules/navigation/components/ProjectCommunicationsSidebar';
import ProjectCommunicationsListPage from './projectCommunicationsModules/projectCommunicationsList/pages/ProjectCommunicationsListPage';
import ProjectCommunicationDetailPage from './projectCommunicationsModules/projectCommunicationsList/pages/ProjectCommunicationDetailPage';
import ProjectCommunicationNewPage from './projectCommunicationsModules/projectCommunicationsList/pages/ProjectCommunicationNewPage';

import HomeServicesSidebar from './homeServiceModules/navigation/components/HomeServicesSidebar';
import InspectionReportListPage from './homeServiceModules/inspectionReport/pages/InspectionReportListPage';
import InspectionReportShowPage from './homeServiceModules/inspectionReport/pages/InspectionReportShowPage';
import UpcomingJobsPage from './homeServiceModules/upcomingJobs/pages/UpcomingJobsPage';
import UpcomingJobFillPage from './homeServiceModules/upcomingJobs/pages/UpcomingJobFillPage';
import CustomerNotificationPage from './homeServiceModules/customerNotification/pages/CustomerNotificationPage';
import AlertNotificationPage from './homeServiceModules/alertNotifications/pages/AlertNotificationPage';
import ModuleSettingsPage from './homeServiceModules/moduleSettings/pages/ModuleSettingsPage';

import EmployeePortalSidebar from './employeePortalModules/navigation/components/EmployeePortalSidebar';
import WarehousePickupVendorListPage from './employeePortalModules/warehousePickup/pages/WarehousePickupVendorListPage';
import WarehousePickupVendorPOsPage from './employeePortalModules/warehousePickup/pages/WarehousePickupVendorPOsPage';
import WarehousePickupPODetailsPage from './employeePortalModules/warehousePickup/pages/WarehousePickupPODetailsPage';

import JobSpreadsheetPage from './chillerModules/chillerLogs/pages/JobSpreadsheetPage';
import UserTopNavigation from './homeModules/UserTopNavigation';

import { AuthenticationContext } from './homeModules/auth/contexts/AuthenticationContext';
import NewCustomerRooftopEstimate from './salesEstimateModules/estimateCustomers/pages/NewCustomerRooftopEstimate';
import ExistingCustomerSiteSelection from './salesEstimateModules/estimateCustomers/pages/ExistingCustomerSiteSelection';
import EditRooftopEstimateCustomer from './salesEstimateModules/estimateCustomers/pages/EditRooftopEstimateCustomer';
import ReviewAssets from './salesEstimateModules/estimateCustomers/pages/ReviewAssets';

import RecentEstimates from './salesEstimateModules/recentEstimates/pages/RecentEstimates';
import EstimateDetail from './salesEstimateModules/estimateDetails/pages/EstimateDetail';

import NewEquipment from './salesEstimateModules/estimateCosts/pages/NewEquipment';
import NewCraneAndCurb from './salesEstimateModules/estimateCosts/pages/NewCraneAndCurb';
import NewInstallationCosts from './salesEstimateModules/estimateCosts/pages/NewInstallationCosts';
import NewRebates from './salesEstimateModules/estimateRebates/pages/NewRebates';

import RebateRecordDetailPage from './salesEstimateModules/estimateRebates/pages/RebateRecordDetailPage';
import RebateRecordsListPage from './salesEstimateModules/estimateRebates/pages/RebateRecordsListPage';

import EquipmentCostsList from './salesEstimateModules/costSettings/pages/EquipmentCostsList';
import EquipmentCostEdit from './salesEstimateModules/costSettings/pages/EquipmentCostEdit';
import EquipmentCostNew from './salesEstimateModules/costSettings/pages/EquipmentCostNew';

import InstallationCostsList from './salesEstimateModules/costSettings/pages/InstallationCostsList';
import InstallationCostEdit from './salesEstimateModules/costSettings/pages/InstallationCostEdit';
import InstallationCostNew from './salesEstimateModules/costSettings/pages/InstallationCostNew';

import SystemAccessoriesList from './salesEstimateModules/adminSettings/pages/SystemAccessoriesList';
import SystemAccessoriesNew from './salesEstimateModules/adminSettings/pages/SystemAccessoriesNew';
import SystemAccessoriesEdit from './salesEstimateModules/adminSettings/pages/SystemAccessoriesEdit';

import JobCostsList from './salesEstimateModules/adminSettings/pages/JobCostsList';

import RebatesList from './salesEstimateModules/adminSettings/pages/RebatesList';
import RebateEdit from './salesEstimateModules/adminSettings/pages/RebateEdit';
import RebateNew from './salesEstimateModules/adminSettings/pages/RebateNew';

import MicrosoftAuthPage from './homeModules/auth/pages/MicrosoftAuthPage';
import LoginPage from './homeModules/auth/pages/LoginPage';

import UtilityGeniusForm from './salesEstimateModules/estimateRebates/components/UtilityGeniusForm';
import ChooseIncentives from './salesEstimateModules/estimateRebates/pages/ChooseIncentives';

import UtilityProvidersList from './salesEstimateModules/adminSettings/pages/UtilityProvidersList';
import UtilityProvidersDetail from './salesEstimateModules/adminSettings/pages/UtilityProvidersDetail';

import AdminSidebar from './adminModules/navigation/components/AdminSidebar';
import DeveloperSidebar from './developerModules/navigation/components/DeveloperSidebar';
import UserListPage from './adminModules/users/pages/UserListPage';
import UserEditPage from './adminModules/users/pages/UserEditPage';
import TeamsListPage from './adminModules/users/pages/TeamsListPage';

import XoiJobsList from './salesEstimateModules/adminSettings/pages/XOiJobsList';

import HomeDashboardPage from './homeModules/HomeDashboard';
import TudiSnackbar from './sharedModules/form/components/TudiSnackbar';

import AhriCertificateDetailPage from './energySolutionsModules/existingCustomerSubmission/pages/AhriCertificateDetailPage';
import EnergySolutionsSidebar from './energySolutionsModules/navigation/EnergySolutionsSidebar';
import CustomerLookupPage from './energySolutionsModules/existingCustomerSubmission/pages/CustomerLookupPage';
import NewCustomerPage from './energySolutionsModules/newCustomerSubmission/pages/NewCustomerPage';
import RecentSubmissionsPage from './energySolutionsModules/previousSubmissions/pages/RecentSubmissionsPage';
import CustomerDetailPage from './energySolutionsModules/existingCustomerSubmission/pages/CustomerDetailPage';
import SubmissionDetailPage from './energySolutionsModules/existingCustomerSubmission/pages/SubmissionDetailPage';

import IssueReportDetailPage from './sharedModules/issueReports/pages/IssueReportDetailPage';
import IssueReportListPage from './sharedModules/issueReports/pages/IssueReportListPage';

import ManufacturersListPage from './adminModules/manufacturers/pages/ManufacturersListPage';
import NotificationSettingsListPage from './adminModules/notificationSettings/pages/NotificationSettingsListPage';
import NotificationSettingDetailPage from './adminModules/notificationSettings/pages/NotificationSettingDetailPage';
import AppModulesListPage from './adminModules/appModules/pages/AppModulesListPage';
import AppModuleDetailPage from './adminModules/appModules/pages/AppModuleDetailPage';
import JobExecutionStatusesListPage from './projectCommunicationsModules/jobExecutionStatuses/pages/JobExecutionStatusesListPage';
import XoiJobsListPage from './developerModules/xoiJobs/pages/XoiJobsListPage';
import XoiJobDetailPage from './developerModules/xoiJobs/pages/XoiJobDetailPage';

import VendorSidebar from './vendorModules/navigation/components/VendorSidebar';
import VendorInvoiceListPage from './vendorModules/invoices/pages/VendorInvoiceListPage';

import CollectionsSidebar from './collectionsModules/navigation/components/CollectionsSidebar';
import CollectionClientsListPage from './collectionsModules/clients/pages/CollectionClientsListPage';
import CollectionConfigPage from './collectionsModules/config/pages/CollectionConfigPage';
import CollectionEmailHistoryPage from './collectionsModules/emailHistory/pages/CollectionEmailHistoryPage';
import CollectionScheduledEmailsPage from './collectionsModules/scheduledEmails/pages/CollectionScheduledEmailsPage';
import VendorInvoiceUploadPage from './vendorModules/invoices/pages/VendorInvoiceUploadPage';
import VendorInvoiceDetailPage from './vendorModules/invoices/pages/VendorInvoiceDetailPage';
import OutlookEmailListPage from './vendorModules/outlookEmails/pages/OutlookEmailListPage';
import OutlookEmailDetailPage from './vendorModules/outlookEmails/pages/OutlookEmailDetailPage';
import EmailReviewPage from './vendorModules/outlookEmails/pages/EmailReviewPage';
import ServmanVendorsListPage from './vendorModules/syncData/pages/ServmanVendorsListPage';
import VendorContactsListPage from './vendorModules/syncData/pages/VendorContactsListPage';
import ServmanInvoicesListPage from './vendorModules/syncData/pages/ServmanInvoicesListPage';
import DocuwareInvoicesListPage from './vendorModules/syncData/pages/DocuwareInvoicesListPage';
import VendorContactDetailAuditPage from './vendorModules/syncData/pages/VendorContactDetailAuditPage';
import VendorReminderListPage from './vendorModules/reminders/pages/VendorReminderListPage';
import VendorReminderTemplatePage from './vendorModules/reminders/pages/VendorReminderTemplatePage';

import PhotoPagesSidebar from './photoPagesModule/components/PhotoPagesSidebar';
import PhotoPagesXoiJobsListPage from './photoPagesModule/pages/PhotoProposalsListPage';
import PhotoProposalDetailPage from './photoPagesModule/pages/PhotoProposalDetailPage';

interface RouteProps {
  msalClientId: any;
}

const NoSidebarPageContent = styled.div`
  margin-left: 0;
  padding: 30px 0;

  @media (min-width: 600px) {
    padding: 30px;
  }

  @media (min-width: 768px) {
    margin-left: -240px;
  }
`;

const ResponsivePageContent = styled.div`
  padding: 30px 16px;

  @media (min-width: 600px) {
    padding: 30px;
  }
`;

// Wide variant: minimal horizontal padding so data-dense tables can use the
// full viewport. Used by ProtectedVendorRoute when wideLayout is set.
const WidePageContent = styled.div`
  padding: 16px 12px;
  width: 100%;
`;

const Routes: React.FC<RouteProps> = (props) => {
  const { msalClientId } = props;

  const { inProgress } = useMsal();
  const isMsalAuthenticated = useIsAuthenticated();
  const { user } = useContext(AuthenticationContext);

  const skipToContentRef = React.useRef<HTMLAnchorElement>(null);

  const [authLoading, setAuthLoading] = React.useState(true);
  const [userLoading, setUserLoading] = React.useState(true);
  const [mobileNavigationActive, setMobileNavigationActive] = React.useState<boolean>(false);
  const [permissionsLoading, setPermissionsLoading] = React.useState<boolean>(false);

  const isDevelopment = import.meta.env.DEV;
  const isAuthenticated = isDevelopment
    ? true // Bypass auth in development
    : msalClientId
      ? isMsalAuthenticated
      : Boolean(user?.id);

  React.useEffect(() => {
    if (inProgress === 'none') {
      setAuthLoading(false);
    }
  }, [inProgress]);

  // Track when user data has been fetched (either successfully or failed)
  React.useEffect(() => {
    if (user !== undefined) {
      setUserLoading(false);
    }
  }, [user]);

  // Wait for both MSAL and user data to load before rendering routes
  if (authLoading || userLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}></div>;
  }

  const SIDEBAR_MAP: Array<[string, React.ReactElement]> = [
    ['/chiller_logs', <ChillerLogSidebar />],
    ['/backflow_tests', <BackflowSidebar />],
    ['/backflow_job_items', <BackflowSidebar />],
    ['/backflows', <BackflowSidebar />],
    ['/energy_solutions', <EnergySolutionsSidebar />],
    ['/ahri_certificates', <EnergySolutionsSidebar />],
    ['/customer_issues', <CustomerIssuesSidebar />],
    ['/project_communications', <ProjectCommunicationsSidebar />],
    ['/developers', <DeveloperSidebar />],
    ['/collections', <CollectionsSidebar />],
    ['/photo_proposals', <PhotoPagesSidebar />],
  ];

  const getSidebar = (routePath: string): React.ReactElement => SIDEBAR_MAP.find(([prefix]) => routePath.startsWith(prefix))?.[1] ?? <SalesEstimateSidebar />;

  const ProtectedRoute = ({ component: Component, path, exact = true, noSidebar = false }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : noSidebar ? <div /> : getSidebar(path)}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <ResponsivePageContent>{permissionsLoading ? <div /> : <Component props={props} component />}</ResponsivePageContent>
          </Frame>
        );
      }}
    />
  );

  const ProtectedHomeServicesRoute = ({ component: Component, path, exact = true, sidebar = <HomeServicesSidebar /> }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : sidebar}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <ResponsivePageContent>{permissionsLoading ? <div /> : <Component props={props} component />}</ResponsivePageContent>
          </Frame>
        );
      }}
    />
  );

  const ProtectedEmployeePortalRoute = ({ component: Component, path, exact = true, sidebar = <EmployeePortalSidebar /> }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : sidebar}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <ResponsivePageContent>{permissionsLoading ? <div /> : <Component props={props} component />}</ResponsivePageContent>
          </Frame>
        );
      }}
    />
  );

  const ProtectedAdminRoute = ({ component: Component, path, exact = true, sidebar = <AdminSidebar /> }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          // Store the intended destination before redirecting to login
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : sidebar}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <ResponsivePageContent>{permissionsLoading ? <div /> : <Component props={props} component />}</ResponsivePageContent>
          </Frame>
        );
      }}
    />
  );

  const ProtectedVendorRoute = ({ component: Component, path, exact = true, sidebar = <VendorSidebar />, wideLayout = false }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          // Store the intended destination before redirecting to login
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        // Wide layout: drop the Polaris navigation drawer and use minimal
        // horizontal padding so the page can use the full viewport width.
        // Used for data-dense pages like the vendor statements table.
        const ContentWrapper = wideLayout ? WidePageContent : ResponsivePageContent;
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={wideLayout ? undefined : permissionsLoading ? <div /> : sidebar}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <ContentWrapper>{permissionsLoading ? <div /> : <Component props={props} component />}</ContentWrapper>
          </Frame>
        );
      }}
    />
  );

  const ProtectedRouteNoSidebar = ({ component: Component, path, exact = true }) => (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (!isAuthenticated) {
          // Store the intended destination before redirecting to login
          sessionStorage.setItem('redirectAfterLogin', props.location.pathname + props.location.search);
          return <Redirect to="/login" />;
        }
        return (
          <Frame
            topBar={<UserTopNavigation mobileNavigationActive={mobileNavigationActive} setMobileNavigationActive={setMobileNavigationActive} />}
            navigation={permissionsLoading ? <div /> : <div />}
            showMobileNavigation={mobileNavigationActive}
            onNavigationDismiss={() => setMobileNavigationActive(false)}
            skipToContentTarget={skipToContentRef}
          >
            <TudiSnackbar />
            <NoSidebarPageContent>{permissionsLoading ? <div /> : <Component props={props} component />}</NoSidebarPageContent>
          </Frame>
        );
      }}
    />
  );

  const AuthRoute = ({ component: Component, path }) => <Route path={path} render={(props) => <Component props={props} component />} />;

  return isAuthenticated || user ? (
    <Switch>
      <ProtectedRouteNoSidebar exact path="/" component={() => <HomeDashboardPage />} />
      <ProtectedRoute exact path="/rooftop_automation/recent" component={() => <RecentEstimates />} />
      <ProtectedRoute exact path="/rooftop_automation/customers/new" component={() => <NewCustomerRooftopEstimate />} />
      <ProtectedRoute exact path="/rooftop_automation/customers/search" component={() => <ExistingCustomerSiteSelection />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/customer" component={() => <EditRooftopEstimateCustomer />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/system" component={() => <ReviewAssets />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/equipment" component={() => <NewEquipment />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/crane_curb" component={() => <NewCraneAndCurb />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/installation_costs" component={() => <NewInstallationCosts />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/rebates" component={() => <NewRebates />} />
      <ProtectedRoute exact path="/rooftop_automation/:estimateId/review" component={() => <EstimateDetail />} />

      <ProtectedRoute exact path="/admin/equipment_costs" component={() => <EquipmentCostsList />} />
      <ProtectedRoute exact path="/admin/equipment_costs/new" component={() => <EquipmentCostNew />} />
      <ProtectedRoute exact path="/admin/equipment_costs/:equipmentCostId/edit" component={() => <EquipmentCostEdit />} />

      <ProtectedRoute exact path="/admin/installation_costs" component={() => <InstallationCostsList />} />
      <ProtectedRoute exact path="/admin/installation_costs/new" component={() => <InstallationCostNew />} />
      <ProtectedRoute exact path="/admin/installation_costs/:installationCostId/edit" component={() => <InstallationCostEdit />} />

      <ProtectedRoute exact path="/admin/system_accessories" component={() => <SystemAccessoriesList />} />
      <ProtectedRoute exact path="/admin/system_accessories/new" component={() => <SystemAccessoriesNew />} />
      <ProtectedRoute exact path="/admin/system_accessories/:systemAccessoryId/edit" component={() => <SystemAccessoriesEdit />} />

      <ProtectedRoute exact path="/admin/job_costs" component={() => <JobCostsList />} />
      <ProtectedRoute exact path="/admin/job_costs/new" component={() => <JobCostsList />} />
      <ProtectedRoute exact path="/admin/:jobCostId/edit" component={() => <JobCostsList />} />

      <ProtectedRoute exact path="/admin/rebates" component={() => <RebatesList />} />
      <ProtectedRoute exact path="/admin/rebates/new" component={() => <RebateNew />} />
      <ProtectedRoute exact path="/admin/rebates/:rebateId/edit" component={() => <RebateEdit />} />

      <ProtectedRoute exact path="/rebate_records/:rebateRecordId" component={() => <RebateRecordDetailPage />} />
      <ProtectedRoute exact path="/rooftop_automation/rebate_records" component={() => <RebateRecordsListPage />} />

      <ProtectedRoute exact path="/admin/utility_providers" component={() => <UtilityProvidersList />} />
      <ProtectedRoute exact path="/admin/utility_providers/:providerId" component={() => <UtilityProvidersDetail />} />

      <ProtectedRoute exact path="/utility-genius-form" component={() => <UtilityGeniusForm />} />
      <ProtectedRoute exact path="/choose-incentives/:utilityId" component={() => <ChooseIncentives />} />

      <ProtectedAdminRoute exact path="/admin/user_management" component={() => <UserListPage />} />
      <ProtectedAdminRoute exact path="/admin/issue_reports" component={() => <IssueReportListPage />} />
      <ProtectedAdminRoute exact path="/admin/user_management/:userId/edit" component={() => <UserEditPage />} />

      <ProtectedAdminRoute exact path="/admin/teams" component={() => <TeamsListPage />} />

      <ProtectedAdminRoute exact path="/admin/manufacturers" component={() => <ManufacturersListPage />} />
      <ProtectedAdminRoute exact path="/admin/notification_settings" component={() => <NotificationSettingsListPage />} />
      <ProtectedAdminRoute exact path="/admin/notification_settings/:notificationSettingId" component={() => <NotificationSettingDetailPage />} />
      <ProtectedAdminRoute exact path="/admin/app_modules" component={() => <AppModulesListPage />} />
      <ProtectedAdminRoute exact path="/admin/app_modules/:appModuleId" component={() => <AppModuleDetailPage />} />

      <ProtectedRoute exact path="/developers/xoi_jobs" component={() => <XoiJobsListPage />} />
      <ProtectedRoute exact path="/developers/xoi_jobs/:xoiJobId" component={() => <XoiJobDetailPage />} />
      <ProtectedRoute exact path="/developers/servman_sql_logs" component={() => <ServmanSqlLogsPage />} />
      <ProtectedRoute exact path="/developers/callback_results" component={() => <CallbackResultsPage />} />

      <ProtectedRoute exact path="/photo_proposals" component={() => <PhotoPagesXoiJobsListPage />} />
      <ProtectedRoute exact path="/photo_proposals/:xoiJobId" component={() => <PhotoProposalDetailPage />} />

      <ProtectedRouteNoSidebar exact path="/issue_reports/:issueReportId" component={() => <IssueReportDetailPage />} />
      <ProtectedRouteNoSidebar exact path="/issue_reports" component={() => <IssueReportListPage />} />

      <ProtectedRoute exact path="/xoi_jobs" component={() => <XoiJobsList />} />

      <ProtectedRoute exact path="/chiller_logs" component={() => <ChillerLogUpcomingJobs role="technician" />} />
      <ProtectedRoute exact path="/chiller_logs/search" component={() => <ChillerLogUpcomingJobs role="technician" />} />
      <ProtectedRoute exact path="/chiller_logs/issue_reports" component={() => <IssueReportListPage />} />
      <ProtectedRoute exact path="/chiller_logs/admin" component={() => <ChillerLogUpcomingJobs role="admin" />} />
      <ProtectedRoute exact path="/chiller_logs/technician" component={() => <ChillerLogUpcomingJobs role="technician" />} />
      <ProtectedRoute exact path="/chiller_logs/approvals" component={() => <ChillerJobApprovalsList />} />
      <ProtectedRoute exact path="/chiller_logs/settings" component={() => <ChillerLogFieldSettingsPage role="admin" />} />
      <ProtectedRoute exact path="/chiller_logs/:id" component={() => <JobSpreadsheetPage />} noSidebar />
      <ProtectedRoute exact path="/chiller_logs/servman_sql_logs" component={() => <ServmanSqlLogsPage category="chillers" />} />

      <ProtectedRoute exact path="/backflow_tests/search" component={() => <BackflowJobGroupsListPage />} />
      <ProtectedRoute exact path="/backflow_tests/unsubmitted" component={() => <UnsubmittedTestsPage />} />
      <ProtectedRoute exact path="/backflow_tests/issue_reports" component={() => <IssueReportListPage />} />
      <ProtectedRoute exact path="/backflow_tests/backflow_job_groups/:backflowJobGroupId/:formAction" component={() => <BackflowJobGroupDetailPage />} />
      <ProtectedRoute exact path="/backflow_tests/backflow_job_groups/:backflowJobGroupId" component={() => <BackflowJobGroupDetailPage />} />
      <ProtectedRoute exact path="/backflow_tests/backflow_form/:id/:formAction" component={() => <BackflowLogPage />} />
      <ProtectedRoute exact path="/backflow_tests/backflow_form/:id" component={() => <BackflowLogPage />} />
      <ProtectedRoute exact path="/backflow_job_items/:id" component={() => <BackflowLogPage />} />
      <ProtectedRoute exact path="/backflow_tests/water_authority_submissions" component={() => <WaterAuthoritySubmissionsPage />} />
      <ProtectedRoute exact path="/backflow_tests/water_authority_submissions/review/:backflowJobGroupId" component={() => <WaterAuthoritySubmissionReviewPage />} />
      <ProtectedRoute exact path="/backflow_tests/approvals" component={() => <BackflowTestApprovalsListPage />} />
      <ProtectedRoute exact path="/backflow_tests/water_authority_configurations" component={() => <WaterAuthorityListPage />} />
      <ProtectedRoute exact path="/backflows/water_authorities/new" component={() => <WaterAuthorityCreatePage />} />
      <ProtectedRoute exact path="/backflows/water_authorities/:waterAuthorityId" component={() => <WaterAuthorityDetailPage />} />
      <ProtectedRoute exact path="/backflow_tests/plumber_config" component={() => <BackflowPlumberDetailsPage />} />
      <ProtectedRoute exact path="/backflow_tests/flagged_devices" component={() => <FlaggedDevicesListPage />} />
      <ProtectedRoute exact path="/backflow_tests/servman_sql_logs" component={() => <ServmanSqlLogsPage category="backflows" />} />

      <ProtectedRoute exact path="/energy_solutions" component={() => <CustomerLookupPage />} />
      <ProtectedRoute exact path="/energy_solutions/customer_lookup" component={() => <CustomerLookupPage />} />
      <ProtectedRoute exact path="/energy_solutions/issue_reports" component={() => <IssueReportListPage />} />
      <ProtectedRoute exact path="/energy_solutions/new_customer" component={() => <NewCustomerPage />} />
      <ProtectedRoute exact path="/energy_solutions/recent_submissions" component={() => <RecentSubmissionsPage />} />
      <ProtectedRoute exact path="/energy_solutions/customers/:customerId" component={() => <CustomerDetailPage />} />
      <ProtectedRoute exact path="/energy_solutions/submissions/:ahriCertificateSubmissionId" component={() => <SubmissionDetailPage />} />
      <ProtectedRoute exact path="/ahri_certificates/:certificateId" component={() => <AhriCertificateDetailPage />} />

      <ProtectedRoute exact path="/customer_issues/servman_sql_logs" component={() => <ServmanSqlLogsPage category="customer_issues" />} />
      <ProtectedRoute exact path="/customer_issues/search" component={() => <CustomerIssuesListPage />} />
      <ProtectedRoute exact path="/customer_issues/:recno" component={() => <CustomerIssueDetailPage />} />

      <ProtectedRoute exact path="/project_communications/servman_sql_logs" component={() => <ServmanSqlLogsPage category="project_communications" />} />
      <ProtectedRoute exact path="/project_communications/search" component={() => <ProjectCommunicationsListPage />} />
      <ProtectedRoute exact path="/project_communications/job_execution_statuses" component={() => <JobExecutionStatusesListPage />} />
      <ProtectedRoute exact path="/project_communications/:jobId/new" component={() => <ProjectCommunicationNewPage />} />
      <ProtectedRoute exact path="/project_communications/:jobId" component={() => <ProjectCommunicationDetailPage />} />

      <ProtectedHomeServicesRoute exact path="/home_services/servman_sql_logs" component={() => <ServmanSqlLogsPage category="home_services" />} />
      <ProtectedHomeServicesRoute exact path="/home_services/upcoming_inspections/:id" component={() => <UpcomingJobFillPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/upcoming_inspections" component={() => <UpcomingJobsPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/reports/:id" component={() => <InspectionReportShowPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/reports" component={() => <InspectionReportListPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/customer_notification" component={() => <CustomerNotificationPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/alert_notifications" component={() => <AlertNotificationPage />} />
      <ProtectedHomeServicesRoute exact path="/home_services/module_settings" component={() => <ModuleSettingsPage />} />

      <ProtectedEmployeePortalRoute exact path="/employee_portal/warehouse_pickup" component={() => <WarehousePickupVendorListPage />} />
      <ProtectedEmployeePortalRoute exact path="/employee_portal/warehouse_pickup/vendors/:vendorId/pos" component={() => <WarehousePickupVendorPOsPage />} />
      <ProtectedEmployeePortalRoute exact path="/employee_portal/warehouse_pickup/pos/:poId/details" component={() => <WarehousePickupPODetailsPage />} />

      <ProtectedVendorRoute exact path="/vendors/invoices" component={() => <VendorInvoiceListPage />} />
      <ProtectedVendorRoute exact path="/vendors/invoices/upload" component={() => <VendorInvoiceUploadPage />} />
      <ProtectedVendorRoute exact path="/vendors/invoices/:id" component={() => <VendorInvoiceDetailPage />} />
      <ProtectedVendorRoute exact path="/vendors/reminders" component={() => <VendorReminderListPage />} />
      <ProtectedVendorRoute exact path="/vendors/reminder-template" component={() => <VendorReminderTemplatePage />} />
      <ProtectedVendorRoute exact path="/vendors/email-review" component={() => <EmailReviewPage />} />
      <ProtectedVendorRoute exact path="/vendors/outlook-emails" component={() => <OutlookEmailListPage />} />
      <ProtectedVendorRoute exact path="/vendors/outlook-emails/:id" component={() => <OutlookEmailDetailPage />} />
      <ProtectedVendorRoute exact path="/vendors/sync/servman-vendors" component={() => <ServmanVendorsListPage />} />
      <ProtectedVendorRoute exact path="/vendors/sync/vendor-contacts" component={() => <VendorContactsListPage />} />
      <ProtectedVendorRoute exact path="/vendors/sync/servman-invoices" component={() => <ServmanInvoicesListPage />} />
      <ProtectedVendorRoute exact path="/vendors/sync/docuware-invoices" component={() => <DocuwareInvoicesListPage />} />
      <ProtectedVendorRoute exact path="/vendors/contact-detail-audit" component={() => <VendorContactDetailAuditPage />} />

      <ProtectedRoute exact path="/collections/clients" component={() => <CollectionClientsListPage />} />
      <ProtectedRoute exact path="/collections/configuration" component={() => <CollectionConfigPage />} />
      <ProtectedRoute exact path="/collections/scheduled-emails" component={() => <CollectionScheduledEmailsPage />} />
      <ProtectedRoute exact path="/collections/email-history" component={() => <CollectionEmailHistoryPage />} />

      <AuthRoute path="/auth" component={() => <MicrosoftAuthPage />} />
      <AuthRoute path="/login" component={() => <LoginPage />} />
      <ProtectedRouteNoSidebar path="/home" component={() => <HomeDashboardPage />} />
    </Switch>
  ) : (
    <Switch>
      <AuthRoute path="/login" component={() => <LoginPage />} />
      <AuthRoute path="/" component={() => <LoginPage />} />
    </Switch>
  );
};

export default Routes;
